// https://usehooks-ts.com/react-hook/use-media-query

import { useEffect, useState } from 'react'

const isClient = typeof window !== 'undefined'

export const breakpoints = {
  /** @deprecated prefer newMobile */
  mobile: '(max-width: 600px)',
  /** @deprecated prefer newTablet */
  tablet: '(max-width: 1024px)',
  newMobile: '(max-width: 700px)',
  newTablet: '(max-width: 1000px)',
  newSmallScreen: '(max-width: 1130px)',
} as const

export function useMediaQuery(query: string): boolean {
  const getMatches = (query: string): boolean => {
    // Prevents SSR issues
    if (isClient) {
      return window.matchMedia(query).matches
    }
    return false
  }

  const [matches, setMatches] = useState<boolean>(false)

  function handleChange() {
    setMatches(getMatches(query))
  }

  useEffect(() => {
    if (!isClient) {
      return
    }

    const matchMedia = window.matchMedia(query)

    // Triggered at the first client-side load and if query changes
    handleChange()

    // Listen matchMedia
    // use addListener & removeListener for Safari < 14
    if (matchMedia.addListener) {
      matchMedia.addListener(handleChange)
    } else {
      matchMedia.addEventListener('change', handleChange)
    }

    return () => {
      if (matchMedia.removeListener) {
        matchMedia.removeListener(handleChange)
      } else {
        matchMedia.removeEventListener('change', handleChange)
      }
    }
  }, [query])

  return matches
}
